import React from 'react';
import {BaseMixin, ElementaryMixin, Tools, NestingLevelMixin} from '../common/common.js';
import Environment from '../environment/environment.js';

import './date-time.less';

export const DateTime = React.createClass({

  //@@viewOn:mixins
  mixins: [
    BaseMixin,
    ElementaryMixin,
    NestingLevelMixin
  ],
  //@@viewOff:mixins

  //@@viewOn:statics
  statics: {
    tagName: 'UU5.Bricks.DateTime',
    nestingLevel: 'inline',
    classNames: {
      main: 'uu5-bricks-date-time',
      timeOnly: 'uu5-bricks-date-time-timeonly',
      dateOnly: 'uu5-bricks-date-time-dateonly',
    },
    defaults: {
      event: Tools.events.dateTime
    },
    warnings: {
      rangeTimeZone: 'Time zone must be in range from -12 to +12. Your time zone was %s.'
    }
  },
  //@@viewOff:statics

  //@@viewOn:propTypes
  propTypes: {
    value: React.PropTypes.oneOfType([
      React.PropTypes.string,
      React.PropTypes.instanceOf(Date)
    ]),
    format: React.PropTypes.string,
    country: React.PropTypes.string,
    timeZone: React.PropTypes.number,
    onChange: React.PropTypes.func,
    dateOnly: React.PropTypes.bool,
    timeOnly: React.PropTypes.bool,
    secondsDisabled: React.PropTypes.bool
  },
  //@@viewOff:propTypes

  //@@viewOn:getDefaultProps
  getDefaultProps() {
    return {
      value: null,
      format: null,
      country: null,
      timeZone: null,
      onChange: null,
      dateOnly: false,
      timeOnly: false,
      secondsDisabled: false
    };
  },
  //@@viewOff:getDefaultProps

  //@@viewOn:standardComponentLifeCycle
  getInitialState() {
    return {
      format: this.props.format,
      country: this.props.country,
      timeZone: this._validateTimeZone(this.props.timeZone || Environment.dateTimeZone)
    };
  },

  componentDidMount() {
    Environment.EventListener.registerDateTime(this.getId(), this._change);
  },

  componentWillReceiveProps(nextProps) {
    if (nextProps.controlled) {
      this.setState({
        format: nextProps.format,
        country: nextProps.country,
        timeZone: this._validateTimeZone(nextProps.timeZone)
      });
    }
  },

  componentWillUnmount() {
    Environment.EventListener.unregisterDateTime(this.getId(), this._change);
  },
  //@@viewOff:standardComponentLifeCycle

  //@@viewOn:interface
  getFormat() {
    return this.state.format;
  },

  setFormat(format, setStateCallback) {
    this.setOptions({ format: format }, setStateCallback);
    return this;
  },

  getCountry() {
    return this.state.country;
  },

  setCountry(country, setStateCallback) {
    this.setOptions({ country: country ? country.toLowerCase() : country }, setStateCallback);
    return this;
  },

  getTimeZone() {
    return this.state.timeZone === null ? this._validateTimeZone(Environment.dateTimeZone) : this.state.timeZone;
  },

  setTimeZone(timeZone, setStateCallback) {
    this.setOptions({ timeZone: timeZone }, setStateCallback);
    return this;
  },

  setOptions(opt, setStateCallback) {
    this.setState({
      format: opt.format === undefined ? this.state.format : opt.format,
      country: opt.country === undefined ? this.state.country : (opt.country ? opt.country.toLowerCase() : opt.country),
      timeZone: opt.timeZone === undefined ? this.state.timeZone : this._validateTimeZone(opt.timeZone)
    }, setStateCallback);
    return this;
  },
  //@@viewOff:interface

  //@@viewOn:overridingMethods
  //@@viewOff:overridingMethods

  //@@viewOn:componentSpecificHelpers
  _change(opt) {
    if (typeof this.props.onChange === 'function') {
      this.props.onChange(this, opt);
    } else {
      this.setOptions(opt);
    }
    return this;
  },

  _formatDateByCountry(date, country) {
    let result;
    if (Environment.dateTimeFormat[country]) {
      result = this._formatDateTime(date, Environment.dateTimeFormat[country]);
    } else {
      result = this._getLocalDateTime(date, country);
    }
    return result;
  },

  _formatDateTime(date, format) {
    if (this.props.secondsDisabled && format) {
      format = format.replace(/:[S]+/, '').replace(/[S]+/, '');
    }
    return Tools.formatDate(date, format, this.state.timeZone);
  },

  _getLocalDateTime(date, country) {
    country = country || [];
    let result, opt;

    if (this.props.secondsDisabled) {
      opt = { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' };
    }

    if (this.props.dateOnly) {
      result = date.toLocaleDateString(country, opt);
    } else if (this.props.timeOnly) {
      result = date.toLocaleTimeString(country, opt);
    } else {
      result = date.toLocaleString(country, opt);
    }

    return result;
  },

  _formatDate(date) {
    let result = null;
    let utc = new Date(date.getTime() + date.getTimezoneOffset() * 60000);
    let newDate = new Date(utc.getTime() + this.state.timeZone * 60 * 60000);

    if (this.state.format) {
      result = this._formatDateTime(newDate, this.state.format);
    } else if (this.state.country) {
      result = this._formatDateByCountry(newDate, this.state.country);
    } else {
      result = this._getLocalDateTime(newDate);
    }

    return result;
  },

  _validateTimeZone(timeZone) {
    if (timeZone < -12) {
      this.showWarning('rangeTimeZone', timeZone);
      timeZone = -12;
    } else if (timeZone > 12) {
      this.showWarning('rangeTimeZone', timeZone);
      timeZone = 12;
    }
    return timeZone;
  },

  _buildMainAttrs() {
    let mainAttrs = this.buildMainAttrs();

    if (this.props.timeOnly) {
      mainAttrs.className += ' ' + this.getClassName().timeOnly;
    } else if (this.props.dateOnly) {
      mainAttrs.className += ' ' + this.getClassName().dateOnly;
    }

    return mainAttrs
  },
  //@@viewOff:componentSpecificHelpers

  //@@viewOn:render
  render: function () {
    let result;

    if (this.getNestingLevel()) {
      let value = typeof this.props.value === 'string' ? new Date(Date.parse(this.props.value)) : this.props.value || new Date();
      result = (
        <span {...this._buildMainAttrs()}>
          {this._formatDate(value)}
          {this.getDisabledCover()}
        </span>
      );
    }

    return result;
  }
  //@@viewOff:render
});

export default DateTime;



// WEBPACK FOOTER //
// ./bricks/date-time.js